import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { ComicLoadingScreen } from "./ComicLoadingScreen";

export default function ProgressBar() {
  const [isRouteChanging, setIsRouteChanging] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleStart = () => setIsRouteChanging(true);
    const handleStop = () => setIsRouteChanging(false);

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleStop);
    router.events.on("routeChangeError", handleStop);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleStop);
      router.events.off("routeChangeError", handleStop);
    };
  }, [router.events]);

  return isRouteChanging ? <ComicLoadingScreen fixed /> : null;
}
